export class Category {
    Name : string = '';
}

export interface CategoryList {
    id: string;
    name: string;
  }
  export interface TagList {
    id: string;
    tagName: string;
  }